export default __webpack_public_path__ + "static/media/donut-chart-right.4f38622a.svg";